export default __webpack_public_path__ + "static/media/Annie Yang- Advisor.4b9dd7dc.jpg";